import { LoaderFunction } from 'react-router-dom';
import { paths } from '@mosey/api-types';
import { getTasksAPIEndDate } from '../../tasks-framework/utils';
import { api } from '../../../utils/fetchApi';

type LocationSummary =
  paths['/api/legal_entity/locations/summary_v2']['get']['responses']['200']['content']['application/json'];

export const locationsLoader: LoaderFunction = ({ params: { locationId } }) => {
  const endDate = getTasksAPIEndDate();

  const summaryParams = new URLSearchParams();

  summaryParams.set('end_date', endDate);

  if (locationId) {
    summaryParams.set('region_codes', locationId);
  }

  return api({
    url: `/api/legal_entity/locations/summary_v2${summaryParams.size > 0 ? `?${summaryParams.toString()}` : ''}`,
    method: 'GET',
  });
};

export const getTodoCountForLocation = (
  {
    question_tasks: questionTasks,
    requirement_tasks: requirementTasks,
  }: LocationSummary,
  locationId: string,
) => {
  const questionTasksForState = questionTasks[locationId.toUpperCase()];
  const requirementTasksForState = requirementTasks[locationId.toUpperCase()];
  let todoCount = 0;

  if (questionTasksForState) {
    todoCount += questionTasksForState.all_count.todo;
  }

  if (requirementTasksForState) {
    todoCount += requirementTasksForState.all_count.todo;
  }

  return todoCount;
};
